/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { Box, Heading, Logo, ThemeTokens } from '@landtrustinc/design-system';
import React from 'react';

const { media } = ThemeTokens;

type LtPlusStepLayoutProps = {
  title: React.ReactNode;
  children: React.ReactNode;
};

const LtPlusStepLayout: React.FC<LtPlusStepLayoutProps> = ({ title, children }) => {
  return (
    <Box display="flex" flexDirection="column" gap="var(--spacing-4)" alignItems="center">
      <Box
        display="flex"
        flexDirection="column"
        textAlign="center"
        gap="var(--spacing-3)"
        mt="var(--spacing-3)"
      >
        <Box display="flex" alignItems="center" justifyContent="center">
          <Logo variant="plus" theme="light" size={47} />
        </Box>

        <Heading
          size="md"
          fontWeight="extrabold"
          textAlign="center"
          css={css`
            font-size: 24px;
            line-height: 28px;

            ${media.sm} {
              font-size: 24px;
              line-height: 28px;
            }
          `}
        >
          {title}
        </Heading>
      </Box>

      {children}
    </Box>
  );
};

export default LtPlusStepLayout;
